import countries from "i18n-iso-countries";
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

const worldWideCountries = () => {
  const worldWideCountries = countries.getNames("en", { select: "official" });

  const countryList = Object.entries(worldWideCountries).reduce(
    (acc, [code, name]) => [...acc, { code, name }],
    []
  );

  return countryList;
};

export default worldWideCountries;
